import React, { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { Spinner } from '../../Components/ui';
import { cx } from '../../Components/ui/utils';
import { resolveCabinetAccess } from '../access';
import { ROLE_MODULES } from '../pages';
import PreviewBar from './PreviewBar';
import '../cabinet.css';

// /cabinet/:role/:page — kirish huquqini tekshiradi va rol sahifasini (lazy) chizadi.
function CabinetRoute({ userRole }) {
  const { role, page } = useParams();
  const access = resolveCabinetAccess({ userRole, routeRole: role, page });
  if (access.redirect) return <Navigate to={access.redirect} replace />;

  const RoleCabinet = ROLE_MODULES[role];
  return (
    <div className={cx('ui-cab', access.preview && 'ui-cab--preview')}>
      <div className="ui-cab__body">
        <Suspense
          fallback={
            <div className="ui-cab__loading">
              <Spinner />
            </div>
          }
        >
          <RoleCabinet page={page} key={`${role}/${page}`} />
        </Suspense>
      </div>
      {access.preview && <PreviewBar role={role} />}
    </div>
  );
}

export default CabinetRoute;
